// Native theme translations for static copy emitted by the custom storefront.
// No external translator runs in a visitor's browser; missing copy stays English.
export const normalizedText=value=>String(value).replace(/\s+/g,' ').trim();
export const nativeText=value=>value.replace(/&(?:amp|quot|apos|lt|gt|nbsp|#39|#x27);/g,entity=>({'&amp;':'&','&quot;':'"','&apos;':"'",'&lt;':'<','&gt;':'>','&nbsp;':' ','&#39;':"'",'&#x27;':"'"}[entity]));
export function translateExact(value,translations){
 const key=normalizedText(value);let candidate=translations[key];
 if(typeof candidate!=='string'||candidate===key){
  const priced=/^((?:[A-Z]{2,3})?[\p{Sc}\s]*\d[\d.,\s]*[\p{Sc}A-Z]{0,3}\s*)(· (?:Choose|Hear|fixed|full details))$/u.exec(key);
  if(priced&&typeof translations[priced[2]]==='string')candidate=priced[1]+translations[priced[2]];
  const complete=/^Complete sets from (.+?)( · Choose)?$/.exec(key);
  if(complete&&typeof translations['Complete sets from']==='string')candidate=translations['Complete sets from']+' '+complete[1]+(complete[2]?' '+(translations['· Choose']||complete[2].trim()):'');
  const cross=/^Also explore (.+) →$/.exec(key);
  if(cross&&typeof translations['Also explore']==='string'&&typeof translations[cross[1]]==='string')candidate=translations['Also explore']+' '+translations[cross[1]]+' →';
  const chooser=/^Choose your (.+)$/.exec(key);
  if(chooser&&typeof translations.Choose==='string')candidate=translations.Choose+' '+(translations[chooser[1]]||chooser[1]);
 }
 if(typeof candidate!=='string'||!candidate||/^translation missing:/i.test(candidate))return value;
 const translated=nativeText(candidate);if(translated===key)return value;
 return value.replace(/\S(?:[\s\S]*\S)?/,translated);
}
export function localizedHref(href,localeRoot,origin){
 const prefix=String(localeRoot||'').replace(/\/$/,'');
 if(!href||href.startsWith('#')||!prefix)return href;
 let url;try{url=new URL(href,origin);}catch{return href;}
 if(url.origin!==origin||!/^\/(?:$|products(?:\/|$)|collections(?:\/|$)|pages(?:\/|$)|blogs(?:\/|$)|cart(?:\/|$)|search(?:\/|$)|policies(?:\/|$))/.test(url.pathname))return href;
 return prefix+url.pathname+url.search+url.hash;
}
if(typeof document!=='undefined'&&!/^en(?:-|$)/i.test(document.documentElement.lang)){
 const payload=document.getElementById('lind-interface-translations');
 if(payload){
  let translations;try{translations=JSON.parse(payload.textContent);}catch{translations={};}
  const excluded='script,style,textarea,input,code,pre,#score,#tune,#myTunesList,[contenteditable],[data-lind-localisation],[data-no-translate]';
  const lastText=new WeakMap(),lastAttributes=new WeakMap();
  const apply=root=>{
   if(!root||root.nodeType!==1||root.closest(excluded))return;
   for(const link of [...(root.matches('a[href]')?[root]:[]),...root.querySelectorAll('a[href]')]){
    const before=link.getAttribute('href'),after=localizedHref(before,payload.getAttribute('data-locale-root'),location.origin);
    if(after!==before)link.setAttribute('href',after);
   }
   const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT),nodes=[];
   while(walker.nextNode())if(!walker.currentNode.parentElement?.closest(excluded))nodes.push(walker.currentNode);
   for(const node of nodes){if(lastText.get(node)===node.nodeValue)continue;const value=translateExact(node.nodeValue,translations);if(value!==node.nodeValue){lastText.set(node,value);node.nodeValue=value;}}
   for(const element of [root,...root.querySelectorAll('[aria-label],[title],[alt],[placeholder]')]){
    if(element.closest(excluded))continue;
    for(const attr of ['aria-label','title','alt','placeholder'])if(element.hasAttribute(attr)){
     const original=element.getAttribute(attr),previous=lastAttributes.get(element)||{};if(previous[attr]===original)continue;
     const value=translateExact(original,translations);if(value!==original){previous[attr]=value;lastAttributes.set(element,previous);element.setAttribute(attr,value);}
    }
   }
  };
  apply(document.body);
  const observer=new MutationObserver(changes=>{
   for(const change of changes){
    if(change.type==='characterData')apply(change.target.parentElement);
    else if(change.type==='attributes')apply(change.target);
    else for(const node of change.addedNodes)apply(node.nodeType===1?node:node.parentElement);
   }
  });
  observer.observe(document.body,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['aria-label','title','alt','placeholder','href']});
 }
}
